import { useEffect, useMemo } from 'react';
import { RootState, useAppSelector } from '../../store.model';
import { GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL } from '../api/Constants';
import { GroupAPI } from '../api/GroupAPI';
import { getGroupByGroupIdSelector } from '../selectors';
import { useGroups } from './useGroups';
import { Base64 } from '../../../util/Base64';
import { GroupStructure } from '../api/GroupAdapter';

/**
 * Get and fetch group from groupID
 * @param deviceId
 * @returns [group, loading, error]
 * 
 * @usage
´´´ts
const { data:group, isLoading, error} = useGroupById("UUID_GROUP")
´´´
 */
export function useGroupById(groupId: string | undefined) {
  const { data: groupsData, ...response } = useGroups();
  const group = useAppSelector((state: RootState) =>
    getGroupByGroupIdSelector(state, { groupId })
  );

  const { data: groupInGroupAPI, ...responseAPI } =
    GroupAPI.useGetGroupByIdQuery(groupId ?? '', {
      skip: !groupId || !!group, // Skip if no groupId or if group already exists in state
      pollingInterval: GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL,
    });

  const returnResponse = group ? { ...response } : { ...responseAPI };

  return {
    data: group ?? groupInGroupAPI,
    ...returnResponse,
  } as const;
}
